<div class="leads-top">
    <div class="leads-top-button-holder">
        <div class="leads-top-button-holder">
            <button
                (click)="toggleFilters()"
                type="button"
                class="show-filter-btn btn-styled">
                <svg-icon
                    *ngIf="!showFilters"
                    src="assets/images/icon-chevron-down.svg"
                    svgClass="svg-icon"></svg-icon>
                <svg-icon
                    *ngIf="showFilters"
                    src="assets/images/icon-chevron-up.svg"
                    svgClass="svg-icon"></svg-icon>
                {{ !showFilters ? 'Show Filters' : 'Hide Filters' }}
            </button>
        </div>
    </div>
    <div
        *ngIf="showFilters"
        class="leads-top-filters">
        <app-lead-list-filters
            [admins]="admins"
            (filtersChanged)="onFiltersChanged($event)"></app-lead-list-filters>
    </div>
</div>
<div class="leads-all">
    <div class="leads-all-header">
        <div class="leads-all-top">
            <div class="leads-all-top-all">
                <div class="leads-all-title">All Leads</div>
                <div class="leads-all-subtitle">
                    <span *ngIf="pParams.totalRecords">
                        Leads in System:
                        <b>
                            {{ pParams.totalRecords }}
                        </b>
                    </span>
                </div>
            </div>
            <div class="leads-all-top-btn-holder">
                <button
                    (click)="openLeadForm()"
                    class="btn btn-styled"
                    type="button">
                    <svg-icon
                        [class]="'btn-svg-icon'"
                        [svgClass]="'icon--button'"
                        src="assets/images/buttons/plus-icon.svg"></svg-icon>
                    Add Lead
                </button>
            </div>
        </div>
        <div class="leads-all-search-holder">
            <input
                [formControl]="searchTerm"
                type="text"
                class="search-text-input"
                placeholder="Search by Name, Email, Phone" />
        </div>
    </div>
    <div
        *yssIsLoading="isLoading && !leads.length"
        class="leads-all-table-holder table-responsive">
        <table
            [dataSource]="leads"
            (matSortChange)="sortData($event)"
            mat-table
            class="mat-elevation-z8 custom-wrap"
            matSort>
            <ng-container matColumnDef="name">
                <th
                    *matHeaderCellDef
                    mat-sort-header
                    sortActionDescription="Sort by Name"
                    mat-header-cell>
                    Name
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.name }}
                </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="phone">
                <th
                    *matHeaderCellDef
                    mat-sort-header
                    mat-header-cell>
                    Phone
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.phone }}
                </td>
            </ng-container>
            <!-- Weight Column -->
            <ng-container matColumnDef="email">
                <th
                    *matHeaderCellDef
                    mat-sort-header
                    mat-header-cell>
                    Email
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.email }}
                </td>
            </ng-container>
            <!-- Symbol Column -->
            <ng-container matColumnDef="accountType">
                <th
                    *matHeaderCellDef
                    mat-header-cell>
                    Customer Type
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.customerType }}
                </td>
            </ng-container>
            <!-- Lead Type Column -->
            <ng-container matColumnDef="leadType">
                <th
                    *matHeaderCellDef
                    mat-header-cell>
                    Lead Type
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    <app-lead-type-chip [isWarm]="lead.isWarm"></app-lead-type-chip>
                </td>
            </ng-container>
            <!-- Sales Manager Column -->
            <ng-container matColumnDef="salesManager">
                <th
                    *matHeaderCellDef
                    mat-header-cell>
                    Sales Manager
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.managerName }}
                </td>
            </ng-container>
            <!-- Date Createdr Column -->
            <ng-container matColumnDef="createdAt">
                <th
                    *matHeaderCellDef
                    mat-sort-header
                    mat-header-cell>
                    Date Created
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    {{ lead.createdAt | date : 'dd.MM.YYYY, hh:mm a' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="options">
                <th
                    *matHeaderCellDef
                    mat-header-cell>
                    &nbsp;
                </th>
                <td
                    *matCellDef="let lead"
                    mat-cell>
                    <img
                        [matMenuTriggerFor]="menu"
                        [matMenuTriggerData]="{ lead: lead }"
                        (click)="$event.stopPropagation()"
                        class="lead-option-icon"
                        src="assets/images/icon-3-dots.svg" />
                </td>
            </ng-container>
            <tbody>
                <tr
                    *matHeaderRowDef="displayedColumns; sticky: true"
                    mat-header-row></tr>
                <tr
                    *matRowDef="let lead; columns: displayedColumns"
                    (click)="selectLead(lead.id)"
                    mat-row></tr>
            </tbody>
        </table>
    </div>
    <div class="leads-pagination-holder">
        <app-pagination
            [params]="pParams"
            (update)="getLeads()"></app-pagination>
    </div>
</div>
<!-- Lead Actions -->
<mat-menu
    #menu="matMenu"
    class="popup-simple-menu action-menu">
    <ng-template
        matMenuContent
        let-lead="lead">
        <button
            *ngIf="twilioService.isDeviceReady && lead.isWarm"
            mat-menu-item>
            <img src="/assets/images/icon-make-call.svg" />
            <span>Make a Call</span>
        </button>
        <button
            [disabled]="true"
            mat-menu-item>
            <img src="/assets/images/icon-mail.svg" />
            <span>Email Message</span>
        </button>
        <button
            *ngIf="lead.isWarm"
            (click)="createOrder(lead)"
            mat-menu-item>
            <img src="/assets/images/icon-new-order.svg" />
            <span>New Order</span>
        </button>
        <button
            [disabled]="true"
            (click)="createOrder(lead)"
            mat-menu-item>
            <img src="/assets/images/chat.svg" />
            <span>Chat Message</span>
        </button>
        <!--<button
            *ngIf="!lead.onHold"
            (click)="placeLeadOnHold(lead)"
            mat-menu-item>
            <img src="/assets/images/icon-place-on-hold.svg" />
            <span>Place on Hold</span>
        </button>-->
        <button
            (click)="archiveLead(lead)"
            mat-menu-item>
            <img src="/assets/images/icon-archive.svg" />
            <span>Archive Lead</span>
        </button>
    </ng-template>
</mat-menu>
